import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { ProviderLicenseCheckResponse } from '../models/providers';

@Injectable({
  providedIn: 'root'
})
export class ProviderLicenseDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  deleteLicenseAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('providerLicenses/Delete', id, timeout);
  }

  checkLicenseExistsAsync(state: string, providerId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { state: state, providerId: providerId, id: id };
    return this.httpClient.getJsonAsync<boolean>('providerLicenses/checkLicenseExists', data, timeout, false);
  }

  checkLicenseAsync(appointmentTypeId: number, providerId: number, clinicId: number, timeout: Promise<any>): Promise<ProviderLicenseCheckResponse> {
    const data = { appointmentTypeId: appointmentTypeId, providerId: providerId, clinicId: clinicId };
    return this.httpClient.getJsonAsync<ProviderLicenseCheckResponse>('providerLicenses/checkLicense', data, timeout, false);
  }

  checkLicenseForAppointmentAsync(providerId: any, appointmentId: number, timeout: Promise<any>): Promise<ProviderLicenseCheckResponse> {
    const data = { providerId: providerId, appointmentId: appointmentId };
    return this.httpClient.getJsonAsync<ProviderLicenseCheckResponse>('providerLicenses/checkLicenseForAppointment', data, timeout, false);
  }
}
